// extracted by mini-css-extract-plugin
export default {"offer-badge":"styles__offer-badge--U2PRn"};